// extracted by mini-css-extract-plugin
module.exports = {"root":"MedicalHistory_root__y2f5E"};